<template>
  <v-container class="ma-0 text-center d-inline">
    <div>
      <v-overlay :absolute="true" :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-treeview
        v-model="selection"
        :items="items"
        :load-children="fetchItems"
        :open.sync="open"
        :active.sync="active"
        :open-on-click="false"
        item-disabled="locked"
        hoverable
        return-object
        item-key="name"
      >
        <template v-slot:prepend="{ item, open }">
          <v-container d-flex v-if="!item.file">
            <v-icon small>{{ open ? "mdi-folder-open" : "mdi-folder" }}</v-icon>
          </v-container>
          <v-icon small v-else>{{
            icons[item.file] ? icons[item.file] : icons["default"]
          }}</v-icon>
        </template>
        <template v-slot:label="{ item }">
          <v-container d-flex>
            <v-col class="mt-1 subtitle-2 text-left text-truncate">{{
              item.name
            }}</v-col>
          </v-container>
        </template>
        <template v-slot:append="{ item }" class="d-flex text-left">
        
          <v-row v-if="!item.masterPath && !bucket.includes('operator')">
            <v-col class="d-flex pa-0" v-if="!item.file && !item.locked">
              <v-col class="text-right pa-0">
                <v-icon
                  class="mx-2"
                  :color="item.checked"
                  :title="'select ' + item.name + ' project'"
                  >mdi-check-box-outline</v-icon
                >
              </v-col>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col class="d-flex pa-0" v-if="!item.file && !item.locked">
              <v-col class="text-right pa-0">
                <v-icon
                  v-if="!item.el_properties.selected"
                  class="mx-2"
                  :color="item.checked"
                  :title="'select ' + item.name + ' project'"
                  @click="_selection(item)"
                  >mdi-selection</v-icon
                >
                <v-icon
                  v-else
                  class="mx-2"
                  :color="item.checked"
                  :title="'select ' + item.name + ' project'"
                  @click="_selection(item)"
                  >mdi-check-box-outline</v-icon
                >
              </v-col>
            </v-col>
          </v-row>
        </template>
      </v-treeview>
    </div>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import path from "path";
import awsmobile from "@/api/aws-exports";

export default {
  props: {
    bucket: {
      type: String,
      default: awsmobile["provider_bucket"],
    },
    parentItem: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    selectionType: "independent",
    nameRules: [(v) => !v || v.length <= 200 || "too long field"],
    selection_icon: "mdi-selection",
    icons: {
      html: "mdi-language-html5",
      js: "mdi-nodejs",
      json: "mdi-json",
      md: "mdi-markdown",
      pdf: "mdi-file-pdf",
      PDF: "mdi-file-pdf",
      png: "mdi-file-image",
      txt: "mdi-file-document-outline",
      xls: "mdi-file-excel",
      xlsx: "mdi-file-excel",
      jpg: "mdi-file-image",
      mp4: "mdi-file-video",
      mkv: "mdi-file-video",
      mp3: "mdi-music",
      dwg: "mdi-database",
      zip: "mdi-folder-zip-outline",
      "7z": "mdi-folder-zip-outline",
      docx: "mdi-file-document-outline",
      doc: "mdi-file-document-outline",
      dwl: "mdi-file-document-outline",
      dwl2: "mdi-file-document-outline",
      default: "mdi-file-document-outline",
    },
    selection: [],
    dialog: false,
    loading: false,
    search: "",
    open: [],
    active: [],
    valid: true,
  }),
  computed: {
    ...mapState({
      pathsToShare: (state) => state.pathsToShare,
      folderToUploadSharedFile: (state) => state.folderToUploadSharedFile
    }),
    items() {
      return this.pathsToShare;
    },
  },
  methods: {
    async _selection(val) {
      this.$store.commit("setFolderToUploadSharedFile", "");
      let folderToUpload = {
        path: val.el_properties.path,
        name: val.el_properties.name,
      };
      await this.$store.dispatch("setFolderToUploadSharedFileAction", folderToUpload);
    },
    async fetchItems(item) {
      let tmp = item.el_properties.name.split("/");
      tmp.pop();
      let ff = "";
      for (let i = 0; i < tmp.length - 1; i++) {
        ff = path.join(ff, tmp[i]);
      }
      await this.$store.dispatch("setTreeToShare", {
        bucket: this.bucket,
        father: item.el_properties.name,
        parent: ff ? ff.concat("/") : ff,
      });
    }
  },
};
</script>
<style>
.v-treeview-node__root {
  height: 20px;
}
</style>